import { Language } from "@/data/model/Enums";
import { reactive } from "vue";



import { clientLanguage } from "@/shared/localization/language";


// the object is reactive and its identity never changes: the language setters replace its
// contents instead of the binding, so every template that reads a translation re-renders on a
// language switch - including the components mounted outside the main vue app by the jquery
// controllers, which no re-mount of that app can reach
export const translations: {
    addToCartPopover: {
        price: string;
        optional: string;
        optionSing: string;
        optionPlur: string;
        chooseExact: string;
        chooseMin: string;
        chooseUpTo: string;
        chooseBetween: string;
        upToTotalItems: string;
        chooseOption: string;
        loadingOptions: string;
        failedLoadingOptions: string;
        adding: string;
    };
    allocation: {
        allocationFailed: string;
    };
    auth: {
        sessionExpiredTitle: string;
        sessionExpiredMessage: string;
        sessionExpiredBecauseAccessRightsChangedMessage: string;
    };
    bill: {
        clearSelection: string;
        exclTip: string;
        fullyPaidItems: string;
        noOrderYet: string;
        paid: string;
        selectAll: string;
    };
    billDiscountsList: {
        itemLevelDiscounts: string;
        orderOrBillLevelDiscounts: string;
        vouchers: string;
    };
    billSection: {
        loadingData: string;
        noPaymentServiceConfigured: string;
        processingPaymentDevicePayment: string;
    };
    cancellation: {
        amount: string;
        bill: string;
        cancellation: string;
        cancellationFailed: string;
        cancellationNotAllowedForPayment: string;
        canStockBeReused: string;
        cancellationSuccessful: string;
        confirmMessage: string;
        confirmTitle: string;
        failedLoading: string;
        loading: string;
        notNow: string;
        notPaid: string;
        offlineMode: string;
        paid: string;
        payment: string;
        paymentMethod: string;
        positionSectionTitle: string;
        positionsText: string;
        reason: string;
        quantity: string;
        status: string;
        submitBtn: string;
        title: string;
        totalIncTip: string;
        user: string;
        wholeOrderText: string;
        singleCancellationFailed: string;
        multipleCancellationsFailed: string;
        refundOutcomeUnknown: string;
        multiplePdPaymentCancellationsNotSupported: string;
        twintOnlineRefundNotSupported: string;
        wholeOrderDesc: string;
        refund: string;
    };
    cancellationReason: {
        reason: string;
    };
    cart: {
        addComment: string;
        failedToAdd: string;
        failedToChange: string;
        failedToRemove: string;
        haveItemsInCart: string;
        noItems: string;
        minimumTotalUnitsPerOrderNotReached: string;
        maximumTotalUnitsPerOrderExceeded: string;
        notAbleToPrepareForCheckout: string;
        order: string;
        paymentBlockingCart: string;
        changingTotalWillRemoveAppliedVouchersMessage: string;
        removeDiscounts: string;
        removeVouchers: string;
    };
    cartItemsList: {
        cart: string;
    };
    changeAllocationDetailsModal: {
        discount: string;
        endUsersCouldNotBeRemoved: string;
        rename: string;
        removeEndUsers: string;
        resetTable: string;
        resetTableText: string;
        transferBill: string;
        transferSelectedBillItems: string;
        print: string;
    };
    currency: {
        chf: string;
    };
    discounts: {
        applyingDiscount: string;
        selectDiscount: string;
        noApplicableDiscountsFound: string;
        removeDiscountPrompt: string;
        removeVoucherPrompt: string;
        removeAllItemDiscountsPrompt: string;
        removeAllItemDiscountsBlockedPrompt: string;
        value: string;
    };
    editOrder: {
        editOrder: string;
    };
    enterContactDataPopover: {
        title: string;
        completeOrderData: string;
    };
    deliveryAddress: {
        deliveryAddress: string;
        enterDeliveryAddress: string;
        street: string;
        postalCodeAndCity: string;
        city: string;
        addressDetails: string;
        postalCode: string;
        country: string;
        minOrderSize: string;
        deliveryFee: string;
        freeDeliveryFrom: string;
        deliveryAddressNotInScopeError: string;
        minimumOrderSizeError: string;
        postalCodeRangeHint: string;
    };
    enums: {
        cancellationMode: {
            Amount: string;
            Positions: string;
            WholeOrder: string;
        };
        cancellationReason: {
            IncorrectIncompleteItemInformation: string;
            OrderedIncorrectlyEndUser: string;
            OrderedIncorrectlyStaffMember: string;
            EndUserChangedMind: string;
            ItemNotAvailable: string;
            PriceWrong: string;
            BusinessClosedAtFulfilmentTime: string;
            LossBreakageStaffMember: string;
            LateFulfilment: string;
            BadQualityPresentation: string;
            LossBreakageEndUser: string;
            CustomerDidNotPayWalkout: string;
            Other: string;
        };
        connectionState: {
            Disconnected: string;
            Connecting: string;
            Connected: string;
            Disconnecting: string;
            Reconnecting: string;
        };
        Country: {
            Austria: string;
            France: string;
            Germany: string;
            Italy: string;
            Netherlands: string;
            Switzerland: string;
        };
        fulfillmentTimeMode: {
            DeliveryTime: string;
            None: string;
            PickupTime: string;
            Time: string;
        };
        reservationAcceptanceState: {
            Open: string;
            PendingOperator: string;
            PendingEndUser: string;
            Accepted: string;
            Declined: string;
        };
        reservationAssignmentState: {
            Unassigned: string;
            Tentative: string;
            Assigned: string;
            Fixed: string;
        };
        reservationAttendanceState: {
            NotArrived: string;
            PartiallyArrived: string;
            Arrived: string;
            PartiallySeated: string;
            Seated: string;
            NoShow: string;
            Completed: string;
        };
    };
    fileUpload: {
        invalidMime: string;
        invalidSize: string;
        noFileSelected: string;
        selectFile: string;
    };
    general: {
        accept: string;
        add: string;
        addingButtonPlaceholder: string;
        anonymousUser: string;
        apply: string;
        back: string;
        cancel: string;
        close: string;
        confirm: string;
        continue: string;
        date: string;
        display: string;
        edit: string;
        end: string;
        error: string;
        failedLoadingData: string;
        firstName: string;
        lastName: string;
        loading: string;
        no: string;
        notSure: string;
        yesContinue: string;
        noSearchResults: string;
        of: string;
        ok: string;
        operationFailed: string;
        pleaseSelect: string;
        reallyRemove: string;
        remove: string;
        reset: string;
        save: string;
        searchTerm: string;
        searchingResults: string;
        start: string;
        time: string;
        today: string;
        unknown: string;
        understood: string;
        yes: string;
    };
    kiosk: {
        tapToStart: string;
        scanToRead: string;
    };
    messages: {
        deviceNotFoundPleaseRefresh: string;
        unauthorizedPleaseRefresh: string;
    };
    linkOffer: {
        childLocation: string;
        offers: string;
        linkedOffers: string;
        linkedOffer: string;
        noLinkedOffers: string;
        noAvailableOptions: string;
        saveAndResetSorting: string;
    };
    offerSection: {
        loadingData: string;
        noActiveOffer: string;
        noOrderServiceConfigured: string;
        removeAllFilters: string;
        timerAlreadyRunning: string;
        timerStartFailed: string;
        timerStopFailed: string;
    };
    order: {
        itemsSelected: string;
    };
    orderAndPayView: {
        failedLoadingOffer: string;
        failedToAllocateToTable: string;
        failedLoadingBill: string;
    };
    openBills: {
        bill: string;
        due: string;
        failedLoadingBills: string;
        loadingData: string;
        noOpenBills: string;
        occupancy: string;
        open: string;
        operator: string;
        ordersForNow: string;
        ordersForNowOrLater: string;
        room: string;
        since: string;
        table: string;
        title: string;
    };
    pay: {
        approximately: string;
        btnOrderAgain: string;
        cartChangedAndPleaseWaitMessage: string;
        cartChangedMessage: string;
        cartChangedTitle: string;
        consumption: string;
        discount: string;
        discountVoucherCode: string;
        discountsMustCoverWholePayLaterOrder: string;
        onlyOneReservationCanBeMadeAtTheTime: string;
        enterTip: string;
        failedBillInvalidSelection: string;
        failedBillPaymentInProgress: string;
        failedEmailNotConfirmed: string;
        failedEndUserEmailNotConfirmed: string;
        failedIdentityNotSignedUp: string;
        failedEndUserNotSignedUp: string;
        failedNoItemsSelected: string;
        failedOutOfStock: string;
        failedPaymentInProgress: string;
        failedPaymentInvalidCard: string;
        failedPaymentUnknownReason: string;
        failedPaymentOutcomeUnknown: string;
        worldlinePaymentOutcomeUnconfirmed: string;
        updatePaymentStatus: string;
        worldlineStatusApproved: string;
        worldlineStatusDeclined: string;
        worldlineTerminalNotConnected: string;
        approvedPaymentNotAccepted: string;
        fees: string;
        billInTransferMode: string;
        fulfillmentSlotTimedOut: string;
        isEmailCorrectQuestion: string;
        newFulfillmentSlotAvailable: string;
        noActivePaymentService: string;
        noFulfillmentSlotAvailable: string;
        tableReservationNoAvailability: string;
        noFulfillmentSlotAvailableV2: string;
        notAllItemsSelected: string;
        paymentInProgressWarning: string;
        paymentRecentlyDoneWarning: string;
        payNow: string;
        pleaseEnterEndUsersEmail: string;
        pleaseEnterYourEmail: string;
        pleaseEnterRequiredData: string;
        pleaseEnterRequiredEndUserData: string;
        received: string;
        scheduledTime: string;
        tip: string;
        total: string;
        totalDiscount: string;
        totalDiscountMismatchError: string;
        twintReturnWarning: string;
        vouchersMustCoverWholePayLaterOrder: string;
        walleePaymentNotAvailable: string;
        pricePerMinuteItemRequiresPayLater: string;
        pricePerMinuteItemAlreadyRunning: string;
    };
    print: {
        orderReceiptPrinted: string;
        failedPrintReceipt: string;
    };
    profile: {
        email: string;
        emailConfirmed: string;
        emailUnconfirmed: string;
    };
    qrScanner: {
        pointCameraQr: string;
        scanQr: string;
    };
    receipt: {
        failedPrintReceipt: string;
        failedSendReceipt: string;
        noProductionSiteEnabledForRoom: string;
        printReceipt: string;
        sendReceipt: string;
        sentReceiptTo: string;
    };
    renameBillModal: {
        billNameLabel: string;
        billNamePlaceholder: string;
    };
    report: {
        paymentMethodsReport: string;
        noAccessToReports: string;
    };
    reservationStatesGrid: {
        decline: string;
        accept: string;
        confirmOrFix: string;
        fix: string;
        removeFix: string;
    };
    roomPlan: {
        failedLoadingTables: string;
        loadingTables: string;
        room: string;
        selectTableToTransferBill: string;
    };
    tableAllocationContextMenu: {
        adjustEndUsersCountFailed: string;
    };
    usesResources: {
        resource: string;
        units: string;
        usesResources: string;
        number: string;
        noResourcesAssigned: string;
    };
} = reactive({}) as any;

// Object.assign takes any object, so the literals below state the shape they have to satisfy -
// without it a mistyped or missing key in one language would go unnoticed
type Translations = typeof translations;

const setEnglish = () => {
    Object.assign(translations, {
        addToCartPopover: {
            price: "Price",
            optional: "Optional",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Select {0} {1}",
            chooseMin: "Select at least {0} {1}",
            chooseUpTo: "Optional. Select up to {0} {1}",
            chooseBetween: "Select {0} - {1} options",
            upToTotalItems: "In total up to {0} items",
            chooseOption: "Select your options",
            loadingOptions: "Options are being loaded...",
            failedLoadingOptions: "Options could not be loaded.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Unfortunately, check-in failed. Please reload the page and try again.",
        },
        auth: {
            sessionExpiredTitle: "Session expired",
            sessionExpiredMessage: "Your session expired. Please log in again.",
            sessionExpiredBecauseAccessRightsChangedMessage: "You have been logged out due to a change in access rights. Please log in again.",
        },
        bill: {
            clearSelection: "Clear selection",
            exclTip: "excl. tip",
            fullyPaidItems: "Fully Paid Items",
            noOrderYet: "Everything is paid, thank you!",
            paid: "Paid",
            selectAll: "Select everything",
        },
        billDiscountsList: {
            itemLevelDiscounts: "Item-level discounts",
            orderOrBillLevelDiscounts: "Order-/Bill-level discounts",
            vouchers: "Vouchers",
        },
        billSection: {
            loadingData: "Loading data...",
            noPaymentServiceConfigured: "No Payment Service configured",
            processingPaymentDevicePayment: "Payment in progress...",
        },
        cancellation: {
            amount: "Amount",
            bill: "Bill",
            cancellation: "Cancellation",
            cancellationFailed: "Order could not be cancelled.",
            cancellationNotAllowedForPayment: "Cancellation is not allowed for this payment",
            canStockBeReused: "Can the stock be reused?",
            cancellationSuccessful: "Cancellation successful",
            confirmMessage: "{{amt}} CHF - do you really want to cancel this? This cannot be reversed.",
            confirmTitle: "Perform cancellation?",
            failedLoading: "Order could not be loaded.",
            loading: "Order is being loaded...",
            notNow: "Not now",
            notPaid: "Not paid",
            offlineMode: "Offline refund",
            paid: "Paid",
            payment: "Payment",
            paymentMethod: "Payment method",
            positionSectionTitle: "Which units of <b>{{itemName}}</b> shall be cancelled?",
            positionsText: "Select the items to be cancelled:",
            reason: "Reason",
            quantity: "Quantity",
            status: "Status",
            submitBtn: "Yes, cancel",
            title: "Cancellation",
            totalIncTip: "Total incl. tip",
            user: "User",
            wholeOrderText: "The entire order will be cancelled.",
            singleCancellationFailed: "Cancellation failed. Please try again.",
            multipleCancellationsFailed: "At least one cancellation failed. Some payments may not have been refunded. Please try again.",
            refundOutcomeUnknown: "It is unclear whether the refund went through. Please check the last transaction on the terminal before cancelling again.",
            multiplePdPaymentCancellationsNotSupported: "This cancellation includes multiple payments via a payment device. Please limit it to a maximum of one payment device payment.",
            twintOnlineRefundNotSupported: "Twint payments made on payment devices cannot be refunded.",
            wholeOrderDesc: "The entire order will be cancelled.",
            refund: "Refund",
        },
        cancellationReason: {
            reason: "Reason",
        },
        cart: {
            addComment: "Add special requests",
            failedToAdd: "Item could not be added.",
            failedToChange: "Item could not be modified.",
            failedToRemove: "Item could not be removed.",
            haveItemsInCart: "You have items in your {0} cart. If you continue, your cart will be deleted.",
            noItems: "No items have been added to the cart yet.",
            minimumTotalUnitsPerOrderNotReached: "Please add {0} more item(s) to your cart to place an order.",
            maximumTotalUnitsPerOrderExceeded: "You can order at most {0} items per order. Please remove some items from your cart.",
            notAbleToPrepareForCheckout: "Cart could not be prepared for payment.",
            order: "Order",
            paymentBlockingCart: "The cart cannot be adjusted while a payment is in progress.",
            changingTotalWillRemoveAppliedVouchersMessage: "Changing the cart / item selection will remove all applied vouchers. You’ll need to reapply them.",
            removeDiscounts: "Remove Discounts",
            removeVouchers: "Remove Vouchers",
        },
        cartItemsList: {
            cart: "Cart",
        },
        changeAllocationDetailsModal: {
            discount: "Discount",
            endUsersCouldNotBeRemoved: "End users could not be removed",
            rename: "Rename",
            removeEndUsers: "Remove end users",
            resetTable: "Check Out Users",
            resetTableText: "Should all {0} users get checked out of {1}? This is not revocable.",
            transferBill: "Transfer",
            transferSelectedBillItems: "Transfer {0} items",
            print: "Print",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            applyingDiscount: "Applying discount...",
            selectDiscount: "Select discount",
            noApplicableDiscountsFound: "No applicable discounts found",
            removeDiscountPrompt: "Remove discount?",
            removeVoucherPrompt: "Remove voucher?",
            removeAllItemDiscountsPrompt: "This will remove all discounts from this item. Remove?",
            removeAllItemDiscountsBlockedPrompt: "Unable to remove discounts because one was used in a payment.",
            value: "Value",
        },
        editOrder: {
            editOrder: "Edit order",
        },
        enterContactDataPopover: {
            title: "Enter contact data",
            completeOrderData: "Complete contact data",
        },
        deliveryAddress: {
            deliveryAddress: "Delivery address",
            enterDeliveryAddress: "Enter delivery address",
            street: "Street & house no.",
            postalCodeAndCity: "Postal code, City",
            city: "City",
            addressDetails: "Address Details",
            postalCode: "Postal Code",
            country: "Country",
            minOrderSize: "Minimum order size",
            deliveryFee: "Delivery fee",
            freeDeliveryFrom: "Free delivery from",
            deliveryAddressNotInScopeError: "Unfortunately, we cannot deliver to this address. Please check the address or try a different one.",
            minimumOrderSizeError: "Minimum order size {0} CHF",
            postalCodeRangeHint: "Separate multiple entries with a comma. To enter a range, use a hyphen without spaces (e.g. 1234-1239).",
        },
        enums: {
            cancellationMode: {
                Amount: "Custom amount",
                Positions: "Individual items",
                WholeOrder: "Entire order",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Incorrect / incomplete item information",
                OrderedIncorrectlyEndUser: "Ordered incorrectly (end user)",
                OrderedIncorrectlyStaffMember: "Ordered incorrectly (staff member)",
                EndUserChangedMind: "End user changed his/her mind",
                ItemNotAvailable: "Item not available",
                PriceWrong: "Price wrong",
                BusinessClosedAtFulfilmentTime: "Business closed at fulfilment time",
                LossBreakageStaffMember: "Loss / Breakage (staff member)",
                LateFulfilment: "Late fulfilment",
                BadQualityPresentation: "Bad quality / presentation",
                LossBreakageEndUser: "Loss / Breakage (end user)",
                CustomerDidNotPayWalkout: "Customer did not pay (walkout)",
                Other: "Other",
            },
            connectionState: {
                Connected: "Connected!",
                Connecting: "Trying to connect...",
                Disconnected: "Disconnected!",
                Disconnecting: "Disconnecting...",
                Reconnecting: "Trying to reconnect...",
            },
            Country: {
                Austria: "Austria",
                France: "France",
                Germany: "Germany",
                Italy: "Italy",
                Netherlands: "Netherlands",
                Switzerland: "Switzerland",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Delivery Time",
                None: "None",
                PickupTime: "Pickup Time",
                Time: "Time (type not specified)",
            },
            reservationAcceptanceState: {
                Open: "Open",
                PendingOperator: "Pending (operator)",
                PendingEndUser: "Pending (end user)",
                Accepted: "Accepted",
                Declined: "Declined",
            },
            reservationAssignmentState: {
                Unassigned: "Unassigned",
                Tentative: "Tentative",
                Assigned: "Assigned",
                Fixed: "Fixed",
            },
            reservationAttendanceState: {
                NotArrived: "Not Arrived",
                PartiallyArrived: "Partially arrived",
                Arrived: "Arrived",
                PartiallySeated: "Partially seated",
                Seated: "Seated",
                NoShow: "No-Show",
                Completed: "Completed",
            },
        },
        fileUpload: {
            invalidMime: "File type is not allowed. Please upload a file in the following format: <b>{{allowed}}</b>",
            invalidSize: "File too large. Maximum size: <b>{{size}}</b>",
            noFileSelected: "No file selected",
            selectFile: "Select file",
        },
        general: {
            accept: "Accept",
            add: "Add",
            addingButtonPlaceholder: "...",
            anonymousUser: "Anonymous end user",
            apply: "Apply",
            back: "Back",
            cancel: "Cancel",
            close: "Close",
            continue: "Continue",
            confirm: "Confirm",
            date: "Date",
            display: "Display",
            edit: "Edit",
            end: "End",
            error: "Error",
            failedLoadingData: "Data could not be loaded.",
            firstName: "First name",
            lastName: "Last name",
            loading: "Loading...",
            no: "No",
            notSure: "Not Sure",
            yesContinue: "Yes, continue",
            noSearchResults: "No results found",
            of: "out of",
            ok: "Ok",
            operationFailed: "The operation could not be performed.",
            pleaseSelect: "Please select",
            reallyRemove: "Are you sure you want to delete this entry permanently?",
            remove: "Remove",
            reset: "Reset",
            save: "Save",
            searchTerm: "Search term...",
            searchingResults: "Searching results...",
            start: "Start",
            time: "Time",
            today: "Today",
            unknown: "Unknown",
            understood: "Understood",
            yes: "Yes",
        },
        kiosk: {
            tapToStart: "Tap to start",
            scanToRead: "Scan to read",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Device not found. The page will reload, please sign in again.",
            unauthorizedPleaseRefresh: "Your session has expired. The page will reload, please try again.",
        },
        linkOffer: {
            childLocation: "Child location",
            offers: "Offers",
            linkedOffers: "Linked offers",
            linkedOffer: "Linked offer",
            noLinkedOffers: "No linked offers",
            noAvailableOptions: "No available options",
            saveAndResetSorting: "Save and reset sorting",
        },
        offerSection: {
            loadingData: "Loading data...",
            noActiveOffer: "No active offer",
            noOrderServiceConfigured: "No Order Service configured",
            removeAllFilters: "Remove all filters",
            timerAlreadyRunning: "The timer of this item is already running at this table.",
            timerStartFailed: "The timer could not be started.",
            timerStopFailed: "The timer could not be stopped.",
        },
        order: {
            itemsSelected: "{0} item(s) selected",
        },
        orderAndPayView: {
            failedLoadingOffer: "Failed to load offer.",
            failedToAllocateToTable: "Check-in failed",
            failedLoadingBill: "Failed to load bill",
        },
        openBills: {
            bill: "Bill",
            due: "Due",
            failedLoadingBills: "Failed to load open bills.<br>Please try again later.",
            loadingData: "Loading data...",
            noOpenBills: "No open bills",
            occupancy: "Occupancy",
            open: "Open",
            operator: "Operator",
            ordersForNow: "Orders for: Now",
            ordersForNowOrLater: "Orders for: Now or later",
            room: "Room",
            since: "Since",
            table: "Table",
            title: "Open bills",
        },
        pay: {
            approximately: "approx.",
            btnOrderAgain: "Order Additionally",
            cartChangedAndPleaseWaitMessage: "Due to lack of availability or a price change at least one item will be deleted from your cart shortly. Please wait a few seconds for the update.",
            cartChangedMessage: "Due to lack of availability or a price change at least one item will be deleted from your cart.",
            cartChangedTitle: "New total price",
            consumption: "Consumption",
            discount: "Discount",
            discountVoucherCode: "Discount / Voucher code",
            discountsMustCoverWholePayLaterOrder: "Discounts have to be paid immediately or be applied to the bill.",
            onlyOneReservationCanBeMadeAtTheTime: "Only one reservation can be made at a time.",
            enterTip: "Enter tip (optional)",
            failedBillInvalidSelection: "At least one selected item has already been paid for or canceled. Please check your selection.",
            failedBillPaymentInProgress: "Another payment is in progress, the affected items have been deselected. Make a payment without these items or try again in a few minutes.",
            failedEmailNotConfirmed: 'Please sign up: Circle at the top right > "Sign Up" > follow instructions. Already signed up? Circle at the top right > "Profile" > “Resend Confirmation E-Mail" > Open and confirm e-mail',
            failedEndUserEmailNotConfirmed: "This email address is not confirmed. Please ask the end user to confirm his email address.",
            failedIdentityNotSignedUp: 'Please sign up: Circle at the top right > "Sign Up"',
            failedEndUserNotSignedUp: "This email address is not registered. Please ask the end user to sign up.",
            failedNoItemsSelected: "No items selected",
            failedOutOfStock: "Desired quantity is unfortunately not available, please adjust the cart:<br />{0}",
            failedPaymentInProgress: "Another payment is in progress. Please wait",
            failedPaymentInvalidCard: "Unfortunately, this brand is not accepted or the card has been rejected by your bank.",
            failedPaymentUnknownReason: "Payment cancelled. Please try again.",
            failedPaymentOutcomeUnknown: "It is unclear whether the card payment went through, the card may have been charged. Check the last transaction on the terminal before paying again.",
            worldlinePaymentOutcomeUnconfirmed: "Transaction unconfirmed. Please update the status. If this message persists, check the terminal or customer device. If the transaction shows as successful there, contact support — otherwise, retry. Please save the customer's contact details.",
            updatePaymentStatus: "Update status",
            worldlineStatusApproved: "The transaction has been confirmed. The payment has been accepted.",
            worldlineStatusDeclined: "The transaction was not approved. The card has not been charged, you can retry.",
            worldlineTerminalNotConnected: "Payment cancelled. Terminal {0} is not connected. Please (re)start the terminal and make sure it is connected.",
            approvedPaymentNotAccepted: "The card payment has been approved, but it could not be saved. Do not pay again – the payment has to be checked manually.",
            fees: "Fees",
            billInTransferMode: "Bill is in transfer mode",
            fulfillmentSlotTimedOut: "The selected time has timed out. Please select a new time.",
            isEmailCorrectQuestion: "Is this correct: {0}?",
            newFulfillmentSlotAvailable: "New {0} {1} due to the selected items or time slot expiry.",
            noActivePaymentService: "No active Payment Service.",
            noFulfillmentSlotAvailable: "Sorry, at least one selected item is not available, please try again later or change your selection.",
            tableReservationNoAvailability: "Sorry, no availability. Please try a different date, time or party size.",
            noFulfillmentSlotAvailableV2: "No availability. {0} might add availability in the future, please check back here soon.",
            notAllItemsSelected: "You haven't selected all units of {0}. Is this correct?",
            paymentInProgressWarning: "Attention, other payment in progress. If you have authorised it with the payment provider, the order will be triggered shortly - please Cancel. If the payment failed or you want to order more, select Order Additionally.",
            paymentRecentlyDoneWarning: 'Attention, potential double order. You have recently successfully ordered, see "Orders" in the side menu (top right circle). Place an additional order?',
            payNow: "Pay",
            pleaseEnterEndUsersEmail: "Please enter the end user's email address.",
            pleaseEnterYourEmail: "Please enter your email or register",
            pleaseEnterRequiredData: "Please enter the required data (marked in red)",
            pleaseEnterRequiredEndUserData: "Please enter the required end user data (marked in red).",
            received: "Received",
            scheduledTime: "scheduled time",
            tip: "Tip",
            total: "Total",
            totalDiscount: "Total discount",
            totalDiscountMismatchError: "The discount or voucher amount has changed. Please try again.",
            twintReturnWarning: "Please return to the browser after payment to speed up the order and receive important information.",
            vouchersMustCoverWholePayLaterOrder: "Voucher balance too low. Please change the payment method or reduce the cart total.",
            walleePaymentNotAvailable: "Sorry, this payment method is currently not available. Try a different one or try later again.",
            pricePerMinuteItemRequiresPayLater: "Your order contains a price per minute item, which can only be ordered with pay later.",
            pricePerMinuteItemAlreadyRunning: "Your order contains a price per minute item that is already running at this table.",
        },
        print: {
            failedPrintReceipt: "Print job failed",
            orderReceiptPrinted: "Print job sent",
        },
        profile: {
            email: "Email",
            emailConfirmed: "Confirmed",
            emailUnconfirmed: "Not confirmed",
        },
        qrScanner: {
            pointCameraQr: "Point your camera at the QR code",
            scanQr: "Scan QR Code",
        },
        receipt: {
            failedPrintReceipt: "Print job failed",
            failedSendReceipt: "Failed to send receipt. Please try again.",
            noProductionSiteEnabledForRoom: "No activated receipt printer is assigned to this table / room.",
            printReceipt: "Print Receipt",
            sendReceipt: "Send Receipt",
            sentReceiptTo: "Receipt was sent to {0}.",
        },
        renameBillModal: {
            billNameLabel: "Bill name",
            billNamePlaceholder: "New bill name...",
        },
        report: {
            paymentMethodsReport: "Payment methods report",
            noAccessToReports: "You don’t have permission to view reports. Contact your administrator / Tastier Support if you think this is a mistake.",
        },
        reservationStatesGrid: {
            decline: "Decline",
            accept: "Accept",
            confirmOrFix: "Confirm, Fix",
            fix: "Fix",
            removeFix: "Remove fix",
        },
        roomPlan: {
            failedLoadingTables: "Failed to load tables.<br />Please try again later.",
            loadingTables: "Loading tables...",
            room: "Room",
            selectTableToTransferBill: "Select destination",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Unable to adjust the number of end users.",
        },
        usesResources: {
            resource: "Resource",
            units: "Units",
            usesResources: "Uses resources",
            number: "Number",
            noResourcesAssigned: "No resource assigned yet..",
        },
    } satisfies Translations);
};

const setGerman = () => {
    Object.assign(translations, {
        addToCartPopover: {
            price: "Preis",
            optional: "Optional",
            optionSing: "Option",
            optionPlur: "Optionen",
            chooseExact: "Wähle {0} {1} aus",
            chooseMin: "Wähle mind. {0} {1} aus",
            chooseUpTo: "Optional. Wähle bis zu {0} {1} aus",
            chooseBetween: "Wähle {0} - {1} Optionen aus",
            upToTotalItems: "Insg. bis zu {0} Artikel",
            chooseOption: "Wähle deine Optionen",
            loadingOptions: "Optionen werden geladen...",
            failedLoadingOptions: "Optionen konnten nicht geladen werden.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Leider ist das Einchecken fehlgeschlagen. Bitte lade die Seite neu und versuche es nochmals.",
        },
        auth: {
            sessionExpiredTitle: "Sitzung abgelaufen",
            sessionExpiredMessage: "Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Sie wurden aufgrund einer Änderung der Zugriffsrechte ausgeloggt. Bitte loggen Sie sich erneut ein.",
        },
        bill: {
            clearSelection: "Auswahl aufheben",
            exclTip: "exkl. Trinkgeld",
            fullyPaidItems: "Vollständig Bezahlte Artikel",
            noOrderYet: "Alles ist bezahlt, danke!",
            paid: "Gezahlt",
            selectAll: "Alles auswählen",
        },
        billDiscountsList: {
            itemLevelDiscounts: "Rabatte auf Artikelebene",
            orderOrBillLevelDiscounts: "Rabatte auf Bestell-/Rechnungsebene",
            vouchers: "Gutscheine",
        },
        billSection: {
            loadingData: "Daten laden...",
            noPaymentServiceConfigured: "Kein Zahlungsdienst konfiguriert",
            processingPaymentDevicePayment: "Zahlung im Gange...",
        },
        cancellation: {
            amount: "Betrag",
            bill: "Rechnung",
            cancellation: "Stornierung",
            cancellationFailed: "Bestellung konnte nicht storniert werden.",
            cancellationNotAllowedForPayment: "Stornierung ist für diese Zahlung nicht erlaubt.",
            canStockBeReused: "Kann der Bestand wiederverwendet werden?",
            cancellationSuccessful: "Stornierung erfolgreich",
            confirmMessage: "{{amt}} CHF wirklich stornieren? Dies kann nicht rückgängig gemacht werden.",
            confirmTitle: "Stornierung ausführen?",
            failedLoading: "Bestellung konnte nicht geladen werden.",
            loading: "Bestellung wird geladen...",
            notNow: "Nicht jetzt",
            notPaid: "Nicht bezahlt",
            offlineMode: "Offline Rückerstattung",
            paid: "Bezahlt",
            payment: "Zahlung",
            paymentMethod: "Zahlungsmittel",
            positionSectionTitle: "Welche Einheiten von <b>{{itemName}}</b> sollen storniert werden?",
            positionsText: "Die zu stornierenden Positionen wählen:",
            reason: "Grund",
            quantity: "Anzahl",
            status: "Status",
            submitBtn: "Ja, stornieren",
            title: "Stornierung",
            totalIncTip: "Total inkl. Trinkgeld",
            user: "Nutzer",
            wholeOrderText: "Die gesamte Bestellung wird storniert werden.",
            singleCancellationFailed: "Stornierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            multipleCancellationsFailed: "Mindestens eine Stornierung ist fehlgeschlagen. Gewisse Zahlungen wurden möglicherweise nicht erstattet. Bitte versuchen Sie es erneut.",
            refundOutcomeUnknown: "Es ist unklar, ob die Rückerstattung durchgeführt wurde. Bitte prüfen Sie die letzte Transaktion am Terminal, bevor Sie erneut stornieren.",
            multiplePdPaymentCancellationsNotSupported: "Diese Stornierung umfasst mehrere Zahlungen über ein Zahlungsgerät. Bitte beschränken Sie sie auf maximal eine Zahlungsgerät-Zahlung.",
            twintOnlineRefundNotSupported: "Twint-Zahlungen, die auf Zahlungsgeräten getätigt wurden, können nicht zurückerstattet werden.",
            wholeOrderDesc: "Die gesamte Bestellung wird storniert werden.",
            refund: "Rückerstattung",
        },
        cancellationReason: {
            reason: "Grund",
        },
        cart: {
            addComment: "Sonderwünsche hinzufügen",
            failedToAdd: "Artikel konnte nicht hinzugefügt werden.",
            failedToChange: "Artikel konnte nicht modifiziert werden.",
            failedToRemove: "Artikel konnte nicht entfernt werden.",
            haveItemsInCart: "Du hast Artikel in deinem {0} Warenkorb. Wenn du fortfährst, wird dein Warenkorb gelöscht.",
            noItems: "Dem Warenkorb wurden noch keine Artikel hinzugefügt.",
            minimumTotalUnitsPerOrderNotReached: "Bitte füge noch {0} Artikel zu deinem Warenkorb hinzu, um eine Bestellung aufzugeben.",
            maximumTotalUnitsPerOrderExceeded: "Du kannst höchstens {0} Artikel pro Bestellung bestellen. Bitte entferne einige Artikel aus deinem Warenkorb.",
            notAbleToPrepareForCheckout: "Warenkorb konnte nicht für die Zahlung vorbereitet werden.",
            order: "Bestellen",
            paymentBlockingCart: "Der Warenkorb kann nicht angepasst werden während eine Zahlung in Bearbeitung ist.",
            changingTotalWillRemoveAppliedVouchersMessage: "Das Ändern des Warenkorbs / der Artikelauswahl entfernt alle angewendeten Gutscheine. Du musst sie danach erneut anwenden.",
            removeDiscounts: "Rabatte Entfernen",
            removeVouchers: "Gutscheine Entfernen",
        },
        cartItemsList: {
            cart: "Warenkorb",
        },
        changeAllocationDetailsModal: {
            discount: "Rabattieren",
            endUsersCouldNotBeRemoved: "Endnutzer konnten nicht entfernt werden",
            rename: "Umbenennen",
            removeEndUsers: "Endnutzer entfernen",
            resetTable: "Nutzer Auschecken",
            resetTableText: "Sollen alle {0} Nutzer von {1} ausgecheckt werden? Dies ist nicht widerrufbar.",
            transferBill: "Übertragen",
            transferSelectedBillItems: "{0} Artikel übertragen",
            print: "Drucken",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            applyingDiscount: "Rabatt wird angewandt...",
            selectDiscount: "Rabatt auswählen",
            noApplicableDiscountsFound: "Keine anwendbaren Rabatte gefunden",
            removeDiscountPrompt: "Rabatt entfernen?",
            removeVoucherPrompt: "Gutschein entfernen?",
            removeAllItemDiscountsPrompt: "Dadurch werden alle Rabatte von diesem Artikel entfernt. Entfernen?",
            removeAllItemDiscountsBlockedPrompt: "Rabatte können nicht entfernt werden, da einer bereits in einer Zahlung verwendet wurde.",
            value: "Wert",
        },
        editOrder: {
            editOrder: "Bestellung bearbeiten",
        },
        enterContactDataPopover: {
            title: "Kontaktdaten eingeben",
            completeOrderData: "Kontaktdaten vervollständigen",
        },
        deliveryAddress: {
            deliveryAddress: "Lieferadresse",
            enterDeliveryAddress: "Lieferadresse eingeben",
            street: "Strasse & Hausnr.",
            postalCodeAndCity: "Postleitzahl, Ort",
            city: "Ort",
            addressDetails: "Address Details",
            postalCode: "Postleitzahl",
            country: "Land",
            minOrderSize: "Mindestbestellwert",
            deliveryFee: "Liefergebühr",
            freeDeliveryFrom: "Kostenlose Lieferung ab",
            deliveryAddressNotInScopeError: "Leider können wir nicht an diese Adresse liefern. Bitte überprüfe die Adresse oder versuche eine andere.",
            minimumOrderSizeError: "Mindestbestellwert {0} CHF",
            postalCodeRangeHint: "Trennen Sie mehrere Einträge mit einem Komma. Um einen Bereich einzugeben, verwenden Sie einen Bindestrich ohne Leerzeichen (z. B. 1234-1239).",
        },
        enums: {
            cancellationMode: {
                Amount: "Manueller Betrag",
                Positions: "Einzelpositionen",
                WholeOrder: "Gesamte Bestellung",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Falsche / unvollständige Artikelinformationen",
                OrderedIncorrectlyEndUser: "Falsch bestellt (Endnutzer)",
                OrderedIncorrectlyStaffMember: "Falsch bestellt (Mitarbeiter)",
                EndUserChangedMind: "Endnutzer hat seine Meinung geändert",
                ItemNotAvailable: "Artikel nicht verfügbar",
                PriceWrong: "Preis falsch",
                BusinessClosedAtFulfilmentTime: "Geschäft zur Erfüllungszeit geschlossen",
                LossBreakageStaffMember: "Bruch / Verlust (Mitarbeiter)",
                LateFulfilment: "Verspätete Erfüllung",
                BadQualityPresentation: "Schlechte Qualität / Präsentation",
                LossBreakageEndUser: "Bruch / Verlust (Endnutzer)",
                CustomerDidNotPayWalkout: "Kunde hat nicht bezahlt (Zechprellerei)",
                Other: "Anderer",
            },
            connectionState: {
                Connected: "Verbunden!",
                Connecting: "Verbindung wird aufgebaut...",
                Disconnected: "Verbindung getrennt!",
                Disconnecting: "Verbindung wird beendet...",
                Reconnecting: "Verbindung wird aufgebaut...",
            },
            Country: {
                Austria: "Österreich",
                France: "Frankreich",
                Germany: "Deutschland",
                Italy: "Italien",
                Netherlands: "Niederlande",
                Switzerland: "Schweiz",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Lieferzeit",
                None: "Nein",
                PickupTime: "Abholzeit",
                Time: "Zeit (Typ nicht spezifiziert)",
            },
            reservationAcceptanceState: {
                Open: "Offen",
                PendingOperator: "Ausstehend (Betreiber)",
                PendingEndUser: "Ausstehend (Endnutzer)",
                Accepted: "Angenommen",
                Declined: "Abgelehnt",
            },
            reservationAssignmentState: {
                Unassigned: "Nicht zugewiesen",
                Tentative: "Vorläufig",
                Assigned: "Zugewiesen",
                Fixed: "Fixiert",
            },
            reservationAttendanceState: {
                NotArrived: "Nicht eingetroffen",
                PartiallyArrived: "Teilweise eingetroffen",
                Arrived: "Eingetroffen",
                PartiallySeated: "Teilweise platziert",
                Seated: "Platziert",
                NoShow: "No-Show",
                Completed: "Abgeschlossen",
            },
        },
        fileUpload: {
            invalidMime: "Dateityp ist nicht erlaubt. Bitte laden Sie eine Datei in folgendem Format hoch: <b>{{allowed}}</b>",
            invalidSize: "Datei zu gross. Maximale Grösse: <b>{{size}}</b>",
            noFileSelected: "Keine Datei ausgewählt",
            selectFile: "Datei auswählen",
        },
        general: {
            accept: "Akzeptieren",
            add: "Hinzufügen",
            addingButtonPlaceholder: "...",
            anonymousUser: "Anonymer Endnutzer",
            apply: "Anwenden",
            back: "Zurück",
            cancel: "Abbrechen",
            close: "Schliessen",
            continue: "Weiter",
            confirm: "Bestätigen",
            date: "Datum",
            display: "Anzeigen",
            edit: "Bearbeiten",
            end: "Ende",
            error: "Fehler",
            failedLoadingData: "Daten konnten nicht geladen werden.",
            firstName: "Vorname",
            lastName: "Nachname",
            loading: "Wird geladen...",
            no: "Nein",
            notSure: "Nicht Sicher",
            yesContinue: "Ja, Weiter",
            noSearchResults: "Keine Resultate gefunden",
            of: "von",
            ok: "Ok",
            operationFailed: "Der Vorgang konnte nicht ausgeführt werden.",
            pleaseSelect: "Bitte auswählen",
            reallyRemove: "Sind Sie sicher, dass Sie diesen Eintrag endgültig löschen möchten?",
            remove: "Löschen",
            reset: "Zurücksetzen",
            save: "Speichern",
            searchTerm: "Suchbegriff...",
            searchingResults: "Suche Resultate...",
            start: "Beginn",
            time: "Uhrzeit",
            today: "Heute",
            unknown: "Unbekannt",
            understood: "Verstanden",
            yes: "Ja",
        },
        kiosk: {
            tapToStart: "Tippen zum Starten",
            scanToRead: "Scanne zum Lesen",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Gerät nicht gefunden. Die Seite wird neu geladen, bitte loggen Sie sich erneut ein.",
            unauthorizedPleaseRefresh: "Deine Sitzung ist abgelaufen. Die Seite wird neu geladen, bitte versuche es nochmals.",
        },
        linkOffer: {
            childLocation: "Untergeordneter Standort",
            offers: "Angebote",
            linkedOffers: "Verknüpfte Angebote",
            linkedOffer: "Verknüpfte Angebot",
            noLinkedOffers: "Keine verknüpften Angebote",
            noAvailableOptions: "Keine verfügbaren Optionen",
            saveAndResetSorting: "Speichern und Reihenfolge zurücksetzen",
        },
        offerSection: {
            loadingData: "Daten laden...",
            noActiveOffer: "Kein aktives Angebot",
            noOrderServiceConfigured: "Kein Bestellservice konfiguriert",
            removeAllFilters: "Alle Filter entfernen",
            timerAlreadyRunning: "Der Timer dieses Artikels läuft an diesem Tisch bereits.",
            timerStartFailed: "Der Timer konnte nicht gestartet werden.",
            timerStopFailed: "Der Timer konnte nicht gestoppt werden.",
        },
        order: {
            itemsSelected: "{0} Artikel ausgewählt",
        },
        orderAndPayView: {
            failedLoadingOffer: "Das Angebot konnte nicht geladen werden.",
            failedToAllocateToTable: "Einchecken fehlgeschlagen",
            failedLoadingBill: "Rechnung konnte nicht geladen werden",
        },
        openBills: {
            bill: "Rechnung",
            due: "Fällig",
            failedLoadingBills: "Offene Rechnungen konnten nicht geladen werden.<br>Bitte versuchen Sie es später erneut.",
            loadingData: "Daten laden...",
            noOpenBills: "Keine offenen Rechnungen",
            occupancy: "Belegung",
            open: "Offen",
            operator: "Bediener",
            ordersForNow: "Bestellungen für: Jetzt",
            ordersForNowOrLater: "Bestellungen für: Jetzt oder später",
            room: "Raum",
            since: "Seit",
            table: "Tisch",
            title: "Offene Rechnungen",
        },
        pay: {
            approximately: "ca.",
            btnOrderAgain: "Zusätzlich Bestellen",
            cartChangedAndPleaseWaitMessage: "Aufgrund von mangelnder Verfügbarkeit oder einer Preisänderung wird mindestens ein Artikel in Kürze aus deinem Warenkorb gelöscht werden. Bitte warte ein paar Sekunden auf die Aktualisierung.",
            cartChangedMessage: "Aufgrund von mangelnder Verfügbarkeit oder einer Preisänderung wird mindestens ein Artikel aus deinem Warenkorb gelöscht.",
            cartChangedTitle: "Neuer Gesamtpreis",
            consumption: "Konsumation",
            discount: "Rabatt",
            discountVoucherCode: "Rabatt- / Gutscheincode",
            discountsMustCoverWholePayLaterOrder: "Rabatte müssen sofort bezahlt oder auf die Rechnung angewandt werden.",
            onlyOneReservationCanBeMadeAtTheTime: "Es kann jeweils nur eine Reservierung vorgenommen werden.",
            enterTip: "Trinkgeld eingeben (optional)",
            failedBillInvalidSelection: "Mindestens ein ausgewählter Artikel ist bereits bezahlt oder storniert worden. Bitte überprüfe deine Auswahl.",
            failedBillPaymentInProgress: "Eine andere Zahlung ist im Gange, die betroffenen Artikel wurden abgewählt. Tätige eine Zahlung ohne diese Artikel oder versuche es in ein paar Minuten erneut.",
            failedEmailNotConfirmed: 'Bitte registriere dich: Kreis oben rechts > "Registrieren" > Anweisungen folgen. Bereits registriert? Kreis oben rechts > "Profil" > "Bestätigungs-E-Mail erneut senden" > E-Mail öffnen und bestätigen',
            failedEndUserEmailNotConfirmed: "Diese E-Mail-Adresse ist nicht bestätigt. Bitte bitten Sie den Endbenutzer, seine E-Mail-Adresse zu bestätigen.",
            failedIdentityNotSignedUp: 'Bitte registriere dich: Kreis oben rechts > "Registrieren"',
            failedEndUserNotSignedUp: "Diese E-Mail-Adresse ist nicht registriert. Bitte bitten Sie den Endbenutzer, sich zu registrieren.",
            failedNoItemsSelected: "Keine Artikel ausgewählt",
            failedOutOfStock: "Gewünschte Anzahl ist leider nicht verfügbar, bitte Warenkorb anpassen:<br />{0}",
            failedPaymentInProgress: "Eine andere Zahlung ist in Bearbeitung. Bitte warten",
            failedPaymentInvalidCard: "Leider wird diese Marke nicht akzeptiert oder die Karte wurde von deiner Bank abgelehnt.",
            failedPaymentUnknownReason: "Zahlung abgebrochen. Bitte versuche es erneut.",
            failedPaymentOutcomeUnknown: "Es ist unklar, ob die Kartenzahlung durchgegangen ist, die Karte wurde möglicherweise belastet. Prüfe die letzte Transaktion am Terminal, bevor du erneut bezahlst.",
            worldlinePaymentOutcomeUnconfirmed: "Transaktion unbestätigt. Bitte aktualisieren Sie den Status. Wenn diese Meldung weiterhin angezeigt wird, überprüfen Sie das Terminal oder das Kundengerät. Wenn die Transaktion dort als erfolgreich angezeigt wird, kontaktieren Sie Support – andernfalls versuchen Sie es erneut. Bitte speichern Sie die Kontaktdaten des Kunden.",
            updatePaymentStatus: "Status aktualisieren",
            worldlineStatusApproved: "Die Transaktion wurde bestätigt. Die Zahlung wurde akzeptiert.",
            worldlineStatusDeclined: "Die Transaktion wurde nicht genehmigt. Die Karte wurde nicht belastet, Sie können es erneut versuchen.",
            worldlineTerminalNotConnected: "Zahlung abgebrochen. Das Terminal {0} ist nicht verbunden. Starten Sie das Terminal (neu) und stellen Sie sicher, dass es verbunden ist.",
            approvedPaymentNotAccepted: "Die Kartenzahlung wurde genehmigt, konnte aber nicht gespeichert werden. Bitte nicht erneut bezahlen – die Zahlung muss manuell geprüft werden.",
            fees: "Gebühren",
            billInTransferMode: "Bill befindet sich im Übertragungsmodus.",
            fulfillmentSlotTimedOut: "Die ausgewählte Zeit ist abgelaufen. Bitte wähle eine neue Zeit.",
            isEmailCorrectQuestion: "Ist dies richtig: {0}?",
            newFulfillmentSlotAvailable: "Neue {0} {1} aufgrund der gewählten Artikel oder Zeitüberschreitung.",
            noActivePaymentService: "Kein aktiver Zahlungsdienst.",
            noFulfillmentSlotAvailable: "Mindestens ein ausgewählter Artikel ist nicht verfügbar. Bitte versuche es später noch einmal oder ändere deine Auswahl.",
            tableReservationNoAvailability: "Sorry, keine Verfügbarkeit. Bitte versuche ein anderes Datum, eine andere Uhrzeit oder eine andere Gruppengrösse. ",
            noFulfillmentSlotAvailableV2: "Keine Verfügbarkeit. {0} wird möglicherweise in Zukunft Verfügbarkeit hinzufügen, bitte schaue bald wieder hier rein.",
            notAllItemsSelected: "Du hast nicht alle Einheiten von {0} ausgewählt. Ist das korrekt?",
            paymentInProgressWarning: "Achtung, andere Zahlung im Gange. Falls du diese beim Zahlungsanbieter genehmigt hast, wird die Bestellung in Kürze ausgelöst - bitte Abbrechen. Wenn die Zahlung fehlschlug oder du mehr bestellen willst, wähle Zusätzlich Bestellen.",
            paymentRecentlyDoneWarning: 'Achtung, potentielle Doppelbestellung. Du hast vor Kurzem erfolgreich bestellt, s. "Bestellungen" im Seitenmenü (Kreis rechts oben). Zusätzliche Bestellung tätigen?',
            payNow: "Zahlen",
            pleaseEnterEndUsersEmail: "Bitte geben Sie die E-Mail-Adresse des Endnutzers ein.",
            pleaseEnterYourEmail: "Bitte E-Mail eingeben oder dich registriere",
            pleaseEnterRequiredData: "Bitte gib die erforderlichen Daten (rot markiert) ein.",
            pleaseEnterRequiredEndUserData: "Bitte geben Sie die erforderlichen Endnutzer-Daten ein (rot markiert).",
            received: "Erhalten",
            scheduledTime: "geplante Uhrzeit",
            tip: "Trinkgeld",
            total: "Total",
            totalDiscount: "Gesamtrabatt",
            totalDiscountMismatchError: "Der Rabatt- oder Gutscheinbetrag hat sich geändert. Bitte versuche es erneut.",
            twintReturnWarning: "Bitte nach der Zahlung zum Browser zurückkehren, um die Bestellung zu beschleunigen und wichtige Informationen zu erhalten.",
            vouchersMustCoverWholePayLaterOrder: "Guthaben des Gutscheins zu niedrig. Bitte ändere das Zahlungsmittel oder reduziere den Warenkorb.",
            walleePaymentNotAvailable: "Entschuldigung, dieses Zahlungsmittel ist vorübergehend nicht verfügbar. Versuche es erneut oder ein anderes Zahlungsmittel.",
            pricePerMinuteItemRequiresPayLater: "Deine Bestellung enthält einen Artikel mit Preis pro Minute, der nur mit späterer Bezahlung bestellt werden kann.",
            pricePerMinuteItemAlreadyRunning: "Deine Bestellung enthält einen Artikel mit Preis pro Minute, der an diesem Tisch bereits läuft.",
        },
        print: {
            failedPrintReceipt: "Druckauftrag fehlgeschlagen",
            orderReceiptPrinted: "Druckauftrag gesendet",
        },
        profile: {
            email: "E-Mail",
            emailConfirmed: "Bestätigt",
            emailUnconfirmed: "Nicht bestätigt",
        },
        qrScanner: {
            pointCameraQr: "Richte deine Kamera auf den QR-Code",
            scanQr: "QR-Code Scannen",
        },
        receipt: {
            failedPrintReceipt: "Receipt could not be printed.",
            failedSendReceipt: "Quittung konnte nicht verschickt werden. Bitte versuche es erneut.",
            noProductionSiteEnabledForRoom: "Diesem Tisch / Raum ist kein aktivierter Quittungsdrucker zugewiesen.",
            printReceipt: "Quittung Drucken",
            sendReceipt: "Quittung Schicken",
            sentReceiptTo: "Quittung wurde an {0} verschickt.",
        },
        renameBillModal: {
            billNameLabel: "Rechnungsname",
            billNamePlaceholder: "Neuer Rechnungsname...",
        },
        report: {
            paymentMethodsReport: "Zahlungsmittelbericht",
            noAccessToReports: "Sie haben keine Berechtigung, Berichte anzusehen. Wenden Sie sich an Ihre(n) Administrator(in) oder den Tastier-Support, wenn Sie glauben, dass es sich um einen Fehler handelt.",
        },
        reservationStatesGrid: {
            decline: "Ablehnen",
            accept: "Annehmen",
            confirmOrFix: "Bestätigen, Fixieren",
            fix: "Fixieren",
            removeFix: "Fixierung aufheben",
        },
        roomPlan: {
            failedLoadingTables: "Tische konnten nicht geladen werden.<br />Bitte versuchen Sie es später erneut.",
            loadingTables: "Tische werden geladen...",
            room: "Raum",
            selectTableToTransferBill: "Ziel auswählen",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Die Anzahl der Endnutzer konnte nicht angepasst werden.",
        },
        usesResources: {
            resource: "Ressource",
            units: "Einheiten",
            usesResources: "Verwendet Ressourcen",
            number: "Anzahl",
            noResourcesAssigned: "No resource assigned yet..",
        },
    } satisfies Translations);
};

const setFrench = () => {
    Object.assign(translations, {
        addToCartPopover: {
            price: "Prezzo",
            optional: "Optionnel",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Sélectionne {0} {1}",
            chooseMin: "Sélectionne au moins {0} {1}",
            chooseUpTo: "Optionnel. Sélectionne au maximum {0} {1}",
            chooseBetween: "Sélectionne {0} - {1} options",
            upToTotalItems: "Au total, jusqu'à {0} articles",
            chooseOption: "Sélectionne tes options",
            loadingOptions: "Les options sont chargées...",
            failedLoadingOptions: "Les options n'ont pas pu être chargées.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Malheureusement, l'enregistrement a échoué. Merci de recharger la page et d'essayer à nouveau.",
        },
        auth: {
            sessionExpiredTitle: "Session expiré",
            sessionExpiredMessage: "Votre session a expiré. Veuillez vous reconnecter.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Vous avez été déconnecté en raison d'une modification des droits d'accès. Veuillez vous reconnecter.",
        },
        bill: {
            clearSelection: "Annuler la sélection",
            exclTip: "excl. pourboire",
            fullyPaidItems: "Articles Payés Intégralement",
            noOrderYet: "Tout est payé, merci!",
            paid: "Payé",
            selectAll: "Tout sélectionner",
        },
        billDiscountsList: {
            itemLevelDiscounts: "Remises au niveau de l’article",
            orderOrBillLevelDiscounts: "Remises au niveau de la commande / note",
            vouchers: "Bons",
        },
        billSection: {
            loadingData: "Chargement des données...",
            noPaymentServiceConfigured: "Pas de service de paiement configuré",
            processingPaymentDevicePayment: "Paiement en cours...",
        },
        cancellation: {
            amount: "Montant",
            bill: "Note",
            cancellation: "Annulation",
            cancellationFailed: "La commande n'a pas pu être annulée.",
            cancellationNotAllowedForPayment: "L’annulation n’est pas autorisée pour ce paiement.",
            canStockBeReused: "Le stock peut-il être réutilisé?",
            cancellationSuccessful: "Annulation réussie",
            confirmMessage: "{{amt}} CHF vraiment annuler ? Cela ne peut pas être annulé.",
            confirmTitle: "Effectuer l'annulation ?",
            failedLoading: "La commande n'a pas pu être chargée.",
            loading: "Commande en cours de chargement...",
            notNow: "Pas maintenant",
            notPaid: "Non payé",
            offlineMode: "Remboursement hors ligne",
            paid: "Payé",
            payment: "Paiement",
            paymentMethod: "Moyen de paiement",
            positionSectionTitle: "Quelles unités de <b>{{itemName}}</b> doivent être annulées ?",
            positionsText: "Sélectionner les postes à annuler :",
            reason: "Raison",
            quantity: "Quantité",
            status: "Statut",
            submitBtn: "Oui, annuler",
            title: "Annulation",
            totalIncTip: "Total (y compris le pourboire)",
            user: "Utilisateur",
            wholeOrderText: "La commande entière sera annulée.",
            singleCancellationFailed: "L'annulation a échoué. Veuillez réessayer.",
            multipleCancellationsFailed: "Au moins une annulation a échoué. Certains paiements n’ont peut-être pas été remboursés. Veuillez réessayer.",
            refundOutcomeUnknown: "Impossible de savoir si le remboursement a abouti. Veuillez vérifier la dernière transaction sur le terminal avant d'annuler à nouveau.",
            multiplePdPaymentCancellationsNotSupported: "Cette annulation comprend plusieurs paiements via un appareil de paiement. Veuillez la limiter à un seul paiement via appareil de paiement.",
            twintOnlineRefundNotSupported: "Les paiements Twint effectués sur des appareils de paiement ne peuvent pas être remboursés.",
            wholeOrderDesc: "La commande entière sera annulée.",
            refund: "Remboursement",
        },
        cancellationReason: {
            reason: "Raison",
        },
        cart: {
            addComment: "Ajouter des demandes spéciales",
            failedToAdd: "L'article n'a pas pu être ajouté.",
            failedToChange: "L'article n'a pas pu être modifié.",
            failedToRemove: "L'article n'a pas pu être supprimé.",
            haveItemsInCart: "Tu as des articles dans ton panier {0}. Si tu continues, ton panier sera supprimé.",
            noItems: "Aucun article n'a encore été ajouté au panier.",
            minimumTotalUnitsPerOrderNotReached: "Ajoute encore {0} article(s) à ton panier pour passer une commande.",
            maximumTotalUnitsPerOrderExceeded: "Tu peux commander au maximum {0} articles par commande. Retire quelques articles de ton panier.",
            notAbleToPrepareForCheckout: "Le panier n'a pas pu être préparé pour le paiement.",
            order: "Commander",
            paymentBlockingCart: "Le panier ne peut pas être modifié pendant qu'un paiement est en cours.",
            changingTotalWillRemoveAppliedVouchersMessage: "La modification du panier / de la sélection d’articles supprimera tous les bons appliqués. Tu devras les réappliquer.",
            removeDiscounts: "Supprimer les Remises",
            removeVouchers: "Supprimer les Bons",
        },
        cartItemsList: {
            cart: "Panier",
        },
        changeAllocationDetailsModal: {
            discount: "Remiser",
            endUsersCouldNotBeRemoved: "Les utilisateurs finaux n'ont pas pu être supprimés",
            rename: "Renommer",
            removeEndUsers: "Supprimer les utilisateurs finaux",
            resetTable: "Check-Out Des Utilisateurs",
            resetTableText: "Tous les {0} utilisateurs doivent être retirés de {1}? Ceci n'est pas révocable.",
            transferBill: "Transférer",
            transferSelectedBillItems: "Transférer {0} articles",
            print: "Imprimer",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            applyingDiscount: "Rabais en cours d'application...",
            selectDiscount: "Sélectionner un rabais",
            noApplicableDiscountsFound: "Aucun rabais applicable trouvé",
            removeDiscountPrompt: "Supprimer la remise ?",
            removeVoucherPrompt: "Supprimer le bon ?",
            removeAllItemDiscountsPrompt: "Cela supprimera toutes les remises de cet article. Supprimer ?",
            removeAllItemDiscountsBlockedPrompt: "Impossible de supprimer les rabais car l’un d’eux a déjà été utilisé dans un paiement.",
            value: "Valeur",
        },
        editOrder: {
            editOrder: "Modifier la commande",
        },
        enterContactDataPopover: {
            title: "Saisir les coordonnées",
            completeOrderData: "Compléter les coordonnées",
        },
        deliveryAddress: {
            deliveryAddress: "Adresse de livraison",
            enterDeliveryAddress: "Saisir l'adresse de livraison",
            street: "Rue & n° de maison",
            postalCodeAndCity: "Code postal, Ville",
            city: "Ville",
            addressDetails: "Address Details",
            postalCode: "Code postal",
            country: "Pays",
            minOrderSize: "Montant minimum de commande",
            deliveryFee: "Frais de livraison",
            freeDeliveryFrom: "Livraison gratuite à partir de",
            deliveryAddressNotInScopeError: "Désolé, nous ne pouvons pas livrer à cette adresse. Vérifie l'adresse ou essaie une autre.",
            minimumOrderSizeError: "Montant minimum de commande {0} CHF",
            postalCodeRangeHint: "Séparez plusieurs entrées par une virgule. Pour entrer une plage, utilisez un tiret sans espaces (par ex. 1234-1239).",
        },
        enums: {
            cancellationMode: {
                Amount: "Montant manuel",
                Positions: "Postes individuels",
                WholeOrder: "Commande entière",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Informations incorrectes ou incomplètes sur l'article",
                OrderedIncorrectlyEndUser: "Commandé de manière incorrecte (utilisateur final)",
                OrderedIncorrectlyStaffMember: "Commandé de manière incorrecte (membre du personnel)",
                EndUserChangedMind: "L'utilisateur final a changé d'avis",
                ItemNotAvailable: "Article non disponible",
                PriceWrong: "Prix erroné",
                BusinessClosedAtFulfilmentTime: "Entreprise fermée au moment de l'exécution",
                LossBreakageStaffMember: "Casse / Perte (membre du personnel)",
                LateFulfilment: "Exécution tardive",
                BadQualityPresentation: "Mauvaise qualité / présentation",
                LossBreakageEndUser: "Casse / Perte (utilisateur final)",
                CustomerDidNotPayWalkout: "Le client n'a pas payé (Délit de fuite)",
                Other: "Autre",
            },
            connectionState: {
                Connected: "Connecté!",
                Connecting: "Connexion en cours...",
                Disconnected: "Déconnecté!",
                Disconnecting: "Déconnexion en cours...",
                Reconnecting: "Reconnexion en cours...",
            },
            Country: {
                Austria: "Autriche",
                France: "France",
                Germany: "Allemagne",
                Italy: "Italie",
                Netherlands: "Pays-Bas",
                Switzerland: "Suisse",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Heure de livraison",
                None: "Non",
                PickupTime: "Heure de retrait",
                Time: "Temps (type non spécifié)",
            },
            reservationAcceptanceState: {
                Open: "Ouvert",
                PendingOperator: "En attente (opérateur)",
                PendingEndUser: "En attente (utilisateur)",
                Accepted: "Accepté",
                Declined: "Refusé",
            },
            reservationAssignmentState: {
                Unassigned: "Non attribué",
                Tentative: "Provisoire",
                Assigned: "Attribué",
                Fixed: "Fixé",
            },
            reservationAttendanceState: {
                NotArrived: "Non arrivé",
                PartiallyArrived: "Partiellement arrivé",
                Arrived: "Arrivé",
                PartiallySeated: "Partiellement installé",
                Seated: "Installé",
                NoShow: "No-Show",
                Completed: "Réalisé",
            },
        },
        fileUpload: {
            invalidMime: "Le type de fichier n'est pas autorisé. Veuillez télécharger un fichier dans le format suivant : <b>{{allowed}}</b>",
            invalidSize: "Fichier trop volumineux. Taille maximale : <b>{{size}}</b>",
            noFileSelected: "Aucun fichier sélectionné",
            selectFile: "Sélectionner un fichier",
        },
        general: {
            accept: "Accepter",
            add: "Ajouter",
            addingButtonPlaceholder: "...",
            anonymousUser: "Utilisateur final anonyme",
            apply: "Appliquer",
            back: "Retour",
            cancel: "Annuler",
            close: "Fermer",
            continue: "Continuer",
            confirm: "Bestätigen",
            date: "Date",
            display: "Afficher",
            edit: "Modifier",
            end: "Fin",
            error: "Erreur",
            failedLoadingData: "Les données n'ont pas pu être chargées.",
            firstName: "Prénom",
            lastName: "Nom",
            loading: "En cours de chargement...",
            no: "Non",
            notSure: "Pas Sûr",
            yesContinue: "Oui, Continuer",
            noSearchResults: "Aucun résultat trouvé",
            of: "sur",
            ok: "Ok",
            operationFailed: "L'opération n'a pas pu être réalisée.",
            pleaseSelect: "Merci de sélectionner",
            reallyRemove: "Êtes-vous sûr de vouloir supprimer définitivement cette entrée ?",
            remove: "Effacer",
            reset: "Réinitialiser",
            save: "Sauvegarder",
            searchTerm: "Terme de recherche...",
            searchingResults: "En cherchant les résultats...",
            start: "Début",
            time: "Heure",
            today: "Aujourd'hui",
            unknown: "Inconnu",
            understood: "Compris",
            yes: "Oui",
        },
        kiosk: {
            tapToStart: "Appuyer pour commencer",
            scanToRead: "Scanner pour lire",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Appareil non trouvé. La page va se recharger, veuillez vous connecter à nouveau.",
            unauthorizedPleaseRefresh: "Ta session a expiré. La page va se recharger, merci de réessayer.",
        },
        linkOffer: {
            childLocation: "Site enfant",
            offers: "Offres",
            linkedOffers: "Offres liées",
            linkedOffer: "Offre liée",
            noLinkedOffers: "Aucune offre liée",
            noAvailableOptions: "Aucune option disponible",
            saveAndResetSorting: "Enregistrer et réinitialiser l’ordre",
        },
        offerSection: {
            loadingData: "Chargement des données...",
            noActiveOffer: "Pas d'offre active",
            noOrderServiceConfigured: "Pas de Service de Commande configuré",
            removeAllFilters: "Supprimer tous les filtres",
            timerAlreadyRunning: "Le minuteur de cet article tourne déjà à cette table.",
            timerStartFailed: "Le minuteur n'a pas pu être démarré.",
            timerStopFailed: "Le minuteur n'a pas pu être arrêté.",
        },
        order: {
            itemsSelected: "{0} article(s) sélectionné(s)",
        },
        orderAndPayView: {
            failedLoadingOffer: "Échec du chargement de l'offre.",
            failedToAllocateToTable: "Check-in échoué",
            failedLoadingBill: "Échec du chargement de la facture",
        },
        openBills: {
            bill: "Note",
            due: "Due",
            failedLoadingBills: "Échec du chargement des factures ouvertes.<br>Veuillez réessayer plus tard.",
            loadingData: "Chargement des données...",
            noOpenBills: "Pas de notes impayées",
            occupancy: "Occupation",
            open: "Ouvert",
            operator: "Opérateur",
            ordersForNow: "Commandes pour : Maintenant",
            ordersForNowOrLater: "Commandes pour : Maintenant ou plus tard",
            room: "Salle",
            since: "Depuis",
            table: "Table",
            title: "Notes impayées",
        },
        pay: {
            approximately: "env.",
            btnOrderAgain: "Commande Supplémentaire",
            cartChangedAndPleaseWaitMessage: "En raison d'un manque de disponibilité ou d'un changement de prix, au moins un article sera bientôt supprimé de ton panier. Merci de patienter quelques secondes pour la mise à jour.",
            cartChangedMessage: "En raison d'un manque de disponibilité ou d'un changement de prix, au moins un article sera supprimé de ton panier.",
            cartChangedTitle: "Nouveau prix total",
            consumption: "Consommation",
            discount: "Remise",
            discountVoucherCode: "Code de remise / de bon",
            discountsMustCoverWholePayLaterOrder: "Les remises doivent être payées immédiatement ou être appliquées à la note.",
            onlyOneReservationCanBeMadeAtTheTime: "On ne peut effectuer qu'une seule réservation à la fois.",
            enterTip: "Saisir un pourboire (optionnel)",
            failedBillInvalidSelection: "Au moins un des articles sélectionnés a déjà été payé ou annulé. Merci de vérifier ta sélection.",
            failedBillPaymentInProgress: "Un autre paiement est en cours, les articles concernés ont été désélectionnés. Effectue un paiement sans ces articles ou réessaie dans quelques minutes.",
            failedEmailNotConfirmed: 'Merci de t\'inscrire : Cercle en haut à droite > "S\'inscrire" > suivre les instructions. Tu es déjà inscrit ? Cercle en haut à droite > "Profil" > "Renvoyer l’E-Mail de Confirmation" > ouvrir l\'e-mail et confirmer',
            failedEndUserEmailNotConfirmed: "Cette adresse e-mail n'est pas confirmée. Veuillez demander à l'utilisateur final de confirmer son adresse e-mail.",
            failedIdentityNotSignedUp: "Merci de t'inscrire : Cercle en haut à droite > \"S'inscrire\"",
            failedEndUserNotSignedUp: "Cette adresse e-mail n'est pas enregistrée. Veuillez demander à l'utilisateur final de s'inscrire.",
            failedNoItemsSelected: "Aucun article sélectionné",
            failedOutOfStock: "La quantité souhaitée n'est malheureusement pas disponible, merci d'adapter le panier :<br />{0}",
            failedPaymentInProgress: "Un autre paiement est en cours. Merci de patienter",
            failedPaymentInvalidCard: "Malheureusement, cette marque n'est pas acceptée ou la carte a été refusée par ta banque.",
            failedPaymentUnknownReason: "Paiement annulé. Merci de réessayer.",
            failedPaymentOutcomeUnknown: "Impossible de savoir si le paiement par carte a abouti, la carte a peut-être été débitée. Vérifie la dernière transaction sur le terminal avant de payer à nouveau.",
            worldlinePaymentOutcomeUnconfirmed: "Transaction non confirmée. Veuillez mettre à jour le statut. Si ce message persiste, vérifiez le terminal ou l'appareil du client. Si la transaction y apparaît comme réussie, contactez l'assistance — sinon, réessayez. Veuillez enregistrer les coordonnées du client.",
            updatePaymentStatus: "Mettre à jour le statut",
            worldlineStatusApproved: "La transaction a été confirmée. Le paiement a été accepté.",
            worldlineStatusDeclined: "La transaction n'a pas été approuvée. La carte n'a pas été débitée, vous pouvez réessayer.",
            worldlineTerminalNotConnected: "Paiement annulé. Le terminal {0} n'est pas connecté. (Re)démarrez le terminal et vérifiez qu'il est connecté.",
            approvedPaymentNotAccepted: "Le paiement par carte a été approuvé, mais n'a pas pu être enregistré. Ne paie pas à nouveau – le paiement doit être vérifié manuellement.",
            fees: "Frais",
            billInTransferMode: "Bill est en mode de transfert.",
            fulfillmentSlotTimedOut: "L'heure sélectionnée a expiré. Merci de sélectionner une nouvelle heure.",
            isEmailCorrectQuestion: "Est-ce correct : {0}?",
            newFulfillmentSlotAvailable: "Nouvelle {0} {1} en raison des articles sélectionnés ou d'un dépassement de délai.",
            noActivePaymentService: "Pas de Service de Paiement actif.",
            noFulfillmentSlotAvailable: "Au moins un article sélectionné n'est pas disponible, merci de réessayer plus tard ou de modifier ta sélection.",
            tableReservationNoAvailability: "Désolé, aucune disponibilité. Essaie une autre date, une autre heure ou une autre taille de groupe.",
            noFulfillmentSlotAvailableV2: "Pas de disponibilité. {0} pourrait ajouter des disponibilités dans le futur, merci de revenir ici prochainement.",
            notAllItemsSelected: "Tu n’as pas sélectionné toutes les unités de {0}. Est-ce correct ?",
            paymentInProgressWarning: "Attention, autre paiement en cours. Si tu l'as autorisé chez le prestataire de paiement, la commande sera déclenchée sous peu - merci d’Annuler. Si le paiement a échoué ou si tu veux commander davantage, choisis Commande Supplémentaire.",
            paymentRecentlyDoneWarning: 'Attention, double commande potentielle. Tu as récemment commandé avec succès, voir "Commandes" dans le menu latéral (cercle supérieur droit). Passer une commande supplémentaire ?',
            payNow: "Payer",
            pleaseEnterEndUsersEmail: "Veuillez saisir l'adresse e-mail de l'utilisateur final.",
            pleaseEnterYourEmail: "Merci de saisir ton adresse e-mail ou de t'inscrire",
            pleaseEnterRequiredData: "Merci de saisir les données requises (indiquées en rouge).",
            pleaseEnterRequiredEndUserData: "Veuillez saisir les données requises de l’utilisateur final (indiquées en rouge).",
            received: "Reçu",
            scheduledTime: "heure programmée",
            tip: "Pourboire",
            total: "Total",
            totalDiscount: "Remise totale",
            totalDiscountMismatchError: "Le montant de la remise ou du bon a changé. Merci d’essayer à nouveau.",
            twintReturnWarning: "Merci de retourner au navigateur après le paiement pour accélérer la commande et obtenir des informations importantes.",
            vouchersMustCoverWholePayLaterOrder: "Solde du bon trop faible. Merci de changer le moyen de paiement ou de réduire le montant du panier.",
            walleePaymentNotAvailable: "Désolé, ce moyen de paiement est temporairement indisponible. Essaye à nouveau ou utilise un autre moyen de paiement.",
            pricePerMinuteItemRequiresPayLater: "Ta commande contient un article au prix par minute, qui ne peut être commandé qu'avec un paiement ultérieur.",
            pricePerMinuteItemAlreadyRunning: "Ta commande contient un article au prix par minute qui tourne déjà à cette table.",
        },
        print: {
            failedPrintReceipt: "Travail d'impression échoué",
            orderReceiptPrinted: "Travail d'impression envoyé",
        },
        profile: {
            email: "E-mail",
            emailConfirmed: "Confirmé",
            emailUnconfirmed: "Non confirmé",
        },
        qrScanner: {
            pointCameraQr: "Dirige ton appareil photo en direction du QR code",
            scanQr: "Scanner le QR code",
        },
        receipt: {
            printReceipt: "Imprimer le Reçu",
            failedPrintReceipt: "Travail d'impression échoué",
            noProductionSiteEnabledForRoom: "Aucune imprimante de reçus activée n'est attribuée à cette table / salle.",
            sendReceipt: "Envoyer le Reçu",
            failedSendReceipt: "Le reçu n'a pas pu être envoyée. Merci de réessayer.",
            sentReceiptTo: "Le reçu a été envoyé à {0}.",
        },
        renameBillModal: {
            billNameLabel: "Nom de la note",
            billNamePlaceholder: "Nouveau nom de la note...",
        },
        report: {
            paymentMethodsReport: "Rapport sur les moyens de paiement",
            noAccessToReports: "Vous n’avez pas la permission de consulter les rapports. Veuillez contacter votre administrateur ou le support Tastier si vous pensez qu’il s’agit d’une erreur.",
        },
        reservationStatesGrid: {
            decline: "Refuser",
            accept: "Accepter",
            confirmOrFix: "Confirmer, Fixer",
            fix: "Fixer",
            removeFix: "Supprimer la fixation",
        },
        roomPlan: {
            failedLoadingTables: "Les tables n'ont pas pu être chargées.<br />Veuillez réessayer plus tard.",
            loadingTables: "Chargement des tables...",
            room: "Salle",
            selectTableToTransferBill: "Sélectionner la destination",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Le nombre d’utilisateurs finaux n’a pas pu être ajusté.",
        },
        usesResources: {
            resource: "Ressource",
            units: "Unités",
            usesResources: "Utilise des ressources",
            number: "Nombre",
            noResourcesAssigned: "No resource assigned yet..",
        },
    } satisfies Translations);
};

const setItalian = () => {
    Object.assign(translations, {
        addToCartPopover: {
            price: "Prix",
            optional: "Opzionale",
            optionSing: "opzione",
            optionPlur: "opzioni",
            chooseExact: "Seleziona {0} {1}",
            chooseMin: "Seleziona almeno {0} {1}",
            chooseUpTo: "Opzionale. Seleziona fino a {0} {1}",
            chooseBetween: "Seleziona {0} - {1} opzioni",
            upToTotalItems: "In totale fino a {0} articoli",
            chooseOption: "Seleziona le tue opzioni",
            loadingOptions: "Le opzioni sono caricate...",
            failedLoadingOptions: "Le opzioni non possono essere caricate.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Purtroppo, il check-in non è riuscito. Si prega di ricaricare la pagina e riprovare.",
        },
        auth: {
            sessionExpiredTitle: "Sessione scaduta",
            sessionExpiredMessage: "La sua sessione è scaduta. Effettuare nuovamente il login.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Siete stati disconnessi a causa di una modifica dei diritti di accesso. Si prega di effettuare nuovamente il login.",
        },
        bill: {
            clearSelection: "Annullare la selezione",
            exclTip: "escl. mancia",
            fullyPaidItems: "Articoli Completamente Pagati",
            noOrderYet: "Tutto è pagato, grazie!",
            paid: "Pagato",
            selectAll: "Selezionare tutto",
        },
        billDiscountsList: {
            itemLevelDiscounts: "Sconti a livello di articolo",
            orderOrBillLevelDiscounts: "Sconti a livello di ordine / conto",
            vouchers: "Voucher",
        },
        billSection: {
            loadingData: "Caricamento dati...",
            noPaymentServiceConfigured: "Nessun Servizio di Pagamento configurato",
            processingPaymentDevicePayment: "Pagamento in corso...",
        },
        cancellation: {
            amount: "Importo",
            bill: "Conto",
            cancellation: "Annullamento",
            cancellationFailed: "Non è stato possibile annullare l'ordine.",
            cancellationNotAllowedForPayment: "L'annullamento non è consentito per questo pagamento.",
            canStockBeReused: "Lo stock può essere riutilizzato?",
            cancellationSuccessful: "Cancellazione riuscita",
            confirmMessage: "{{amt}} CHF si annullano davvero? Questo non può essere invertito.",
            confirmTitle: "Effettuare la cancellazione?",
            failedLoading: "L'ordine non può essere caricato.",
            loading: "L'ordine è in fase di caricamento...",
            notNow: "Non adesso",
            notPaid: "Non pagato",
            offlineMode: "Rimborso offline",
            paid: "Pagato",
            payment: "Pagamento",
            paymentMethod: "Mezzo di pagamento",
            positionSectionTitle: "Quali unità di <b>{{itemName}}</b> devono essere cancellate?",
            positionsText: "Selezionare le voci da cancellare:",
            reason: "Motivo",
            quantity: "Quantità",
            status: "Stato",
            submitBtn: "Si, annullare",
            title: "Annullamento",
            totalIncTip: "Totale (mancia inclusa)",
            user: "Utente",
            wholeOrderText: "L'intero ordine verrà annullato.",
            singleCancellationFailed: "La cancellazione è fallita. Si prega di riprovare.",
            multipleCancellationsFailed: "Almeno una cancellazione è fallita. Alcuni pagamenti potrebbero non essere stati rimborsati. Si prega di riprovare.",
            refundOutcomeUnknown: "Non è chiaro se il rimborso sia andato a buon fine. Si prega di controllare l'ultima transazione sul terminale prima di annullare di nuovo.",
            multiplePdPaymentCancellationsNotSupported: "Questa cancellazione include più pagamenti via un dispositivo di pagamento. Si prega di limitarla a un massimo di un pagamento via dispositivo di pagamento.",
            twintOnlineRefundNotSupported: "I pagamenti Twint effettuati su dispositivi di pagamento non possono essere rimborsati.",
            wholeOrderDesc: "L'intero ordine verrà annullato.",
            refund: "Rimborso",
        },
        cancellationReason: {
            reason: "Motivo",
        },
        cart: {
            addComment: "Aggiungere richieste speciali",
            failedToAdd: "L'articolo non può essere aggiunto.",
            failedToChange: "L'articolo non può essere modificato.",
            failedToRemove: "L'articolo non può essere rimosso.",
            haveItemsInCart: "Hai articoli nel tuo carrello di {0}. Se continui, il tuo carrello verrà cancellato.",
            noItems: "Nessun articolo è stato ancora aggiunto al carrello.",
            minimumTotalUnitsPerOrderNotReached: "Aggiungi ancora {0} articolo/i al tuo carrello per effettuare un ordine.",
            maximumTotalUnitsPerOrderExceeded: "Puoi ordinare al massimo {0} articoli per ordine. Rimuovi alcuni articoli dal tuo carrello.",
            notAbleToPrepareForCheckout: "Il carrello non poteva essere preparato per il pagamento.",
            order: "Ordinare",
            paymentBlockingCart: "Il carrello non può essere modificato mentre un pagamento è in corso.",
            changingTotalWillRemoveAppliedVouchersMessage: "La modifica del carrello / della selezione degli articoli rimuoverà tutti i buoni applicati. Dovrai riapplicarli.",
            removeDiscounts: "Rimuovi Sconti",
            removeVouchers: "Rimuovi Voucher",
        },
        cartItemsList: {
            cart: "Carrello",
        },
        changeAllocationDetailsModal: {
            discount: "Scontare",
            endUsersCouldNotBeRemoved: "Non è stato possibile rimuovere gli utenti finali",
            rename: "Rinominare",
            removeEndUsers: "Rimuovere gli utenti finali",
            resetTable: "Checkout l'Utente",
            resetTableText: "Tutti i {0} utenti devono essere rimossi dal {1}? Questo non è revocabile.",
            transferBill: "Trasferire",
            transferSelectedBillItems: "Trasferire {0} articoli",
            print: "Stampare",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            applyingDiscount: "Rabais in corso di applicazione...",
            selectDiscount: "Seleziona lo sconto",
            noApplicableDiscountsFound: "Nessun sconto applicabile trovato",
            removeDiscountPrompt: "Rimuovere lo sconto?",
            removeVoucherPrompt: "Rimuovere il voucher?",
            removeAllItemDiscountsPrompt: "Questo rimuoverà tutti gli sconti da questo articolo. Rimuovere?",
            removeAllItemDiscountsBlockedPrompt: "Impossibile rimuovere gli sconti perché uno è già stato utilizzato in un pagamento.",
            value: "Valore",
        },
        editOrder: {
            editOrder: "Modifica ordine",
        },
        enterContactDataPopover: {
            title: "Inserire i dati di contatto",
            completeOrderData: "Completare i dati di contatto",
        },
        deliveryAddress: {
            deliveryAddress: "Indirizzo di consegna",
            enterDeliveryAddress: "Inserisci l'indirizzo di consegna",
            street: "Via & no.",
            postalCodeAndCity: "Code postal, Ville",
            city: "Città",
            addressDetails: "Address Details",
            postalCode: "Codice postale",
            country: "Paese",
            minOrderSize: "Importo minimo d'ordine",
            deliveryFee: "Costo di consegna",
            freeDeliveryFrom: "Consegna gratuita a partire da",
            deliveryAddressNotInScopeError: "Purtroppo non possiamo consegnare a questo indirizzo. Controlla l'indirizzo o prova un altro.",
            minimumOrderSizeError: "Importo minimo d'ordine {0} CHF",
            postalCodeRangeHint: "Separi le voci multiple con una virgola. Per inserire un intervallo, utilizzi un trattino senza spazi (ad es. 1234-1239).",
        },
        enums: {
            cancellationMode: {
                Amount: "Importo manuale",
                Positions: "Singole voci",
                WholeOrder: "Ordine intero",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Informazioni errate / incomplete sull'articolo",
                OrderedIncorrectlyEndUser: "Ordinato in modo errato (utente finale)",
                OrderedIncorrectlyStaffMember: "Ordinato in modo errato (membro del personale)",
                EndUserChangedMind: "L'utente finale ha cambiato idea",
                ItemNotAvailable: "Articolo non disponibile",
                PriceWrong: "Prezzo sbagliato",
                BusinessClosedAtFulfilmentTime: "Attività chiusa al momento dell'adempimento",
                LossBreakageStaffMember: "Rottura / Perdita (membro del personale)",
                LateFulfilment: "Adempimento tardivo",
                BadQualityPresentation: "Pessima qualità / presentazione",
                LossBreakageEndUser: "Rottura / Perdita (utente finale)",
                CustomerDidNotPayWalkout: "Il cliente non ha pagato (Fuga)",
                Other: "Altro",
            },
            connectionState: {
                Connected: "Connesso!",
                Connecting: "La connessione è stabilita...",
                Disconnected: "Connessione terminata!",
                Disconnecting: "La connessione è terminata....",
                Reconnecting: "La connessione è stabilita...",
            },
            Country: {
                Austria: "Austria",
                France: "Francia",
                Germany: "Germania",
                Italy: "Italia",
                Netherlands: "Paesi Bassi",
                Switzerland: "Svizzera",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Orario di consegna",
                None: "No",
                PickupTime: "Orario di ritiro",
                Time: "Tempo (tipo non specificato)",
            },
            reservationAcceptanceState: {
                Open: "Aperto",
                PendingOperator: "In sospeso (operatore)",
                PendingEndUser: "In sospeso (utente)",
                Accepted: "Accettato",
                Declined: "Rifiutato",
            },
            reservationAssignmentState: {
                Unassigned: "Non assegnato",
                Tentative: "Provvisorio",
                Assigned: "Assegnato",
                Fixed: "Fissato",
            },
            reservationAttendanceState: {
                NotArrived: "Non arrivato",
                PartiallyArrived: "Parzialmente arrivato",
                Arrived: "Arrivato",
                PartiallySeated: "Parzialmente seduto",
                Seated: "Seduto",
                NoShow: "No-Show",
                Completed: "Completato",
            },
        },
        fileUpload: {
            invalidMime: "Il tipo di file non è consentito. Si prega di caricare un file nel seguente formato: <b>{[allowed}}</b>",
            invalidSize: "File troppo grande. Dimensione massima: <b>{{size}}</b>",
            noFileSelected: "Nessun file selezionato",
            selectFile: "Selezionare un file",
        },
        general: {
            accept: "Accettare",
            add: "Aggiungere",
            addingButtonPlaceholder: "...",
            anonymousUser: "Utente finale anonimo",
            apply: "Applica",
            back: "Ritorno",
            cancel: "Cancellare",
            close: "Chiudere",
            continue: "Continuare",
            confirm: "Confirmer",
            date: "Data",
            display: "Mostrare",
            edit: "Modificare",
            end: "Fine",
            error: "Errore",
            failedLoadingData: "I dati non possono essere caricati.",
            firstName: "Nome",
            lastName: "Cognome",
            loading: "Caricamento...",
            no: "No",
            notSure: "Non Sicuro",
            yesContinue: "Sì, Continua",
            noSearchResults: "Nessun risultato trovato",
            of: "su",
            ok: "Ok",
            operationFailed: "L'operazione non può essere eseguita.",
            pleaseSelect: "Si prega di selezionare",
            reallyRemove: "Sei sicuro di voler cancellare questa voce in modo permanente?",
            remove: "Eliminare",
            save: "Salvare",
            searchTerm: "Termine di ricerca...",
            searchingResults: "Cercando i risultati...",
            start: "Inizio",
            reset: "Reset",
            time: "Ora",
            today: "Oggi",
            unknown: "Sconosciuto",
            understood: "Capito",
            yes: "Sì",
        },
        kiosk: {
            tapToStart: "Toccare per iniziare",
            scanToRead: "Inquadra per leggere",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Dispositivo non trovato. La pagina verrà ricaricata, si prega di accedere nuovamente.",
            unauthorizedPleaseRefresh: "La tua sessione è finita. La pagina si ricaricherà, si prega di riprovare.",
        },
        linkOffer: {
            childLocation: "Ubicazione subordinata",
            offers: "Offerte",
            linkedOffers: "Offerte collegate",
            linkedOffer: "Offerta collegata",
            noLinkedOffers: "Nessuna offerta collegata",
            noAvailableOptions: "Nessuna opzione disponibile",
            saveAndResetSorting: "Salvare e reimpostare l’ordine",
        },
        offerSection: {
            loadingData: "Caricamento dati...",
            noActiveOffer: "Nessuna offerta attiva",
            noOrderServiceConfigured: "Nessun Servizio d'Ordine configurato",
            removeAllFilters: "Rimuovere tutti i filtri",
            timerAlreadyRunning: "Il timer di questo articolo è già in corso a questo tavolo.",
            timerStartFailed: "Il timer non può essere avviato.",
            timerStopFailed: "Il timer non può essere arrestato.",
        },
        order: {
            itemsSelected: "{0} articolo/i selezionato/i",
        },
        orderAndPayView: {
            failedLoadingOffer: "Impossibile caricare l'offerta.",
            failedToAllocateToTable: "Check-in fallito",
            failedLoadingBill: "Impossibile caricare la fattura",
        },
        openBills: {
            bill: "Conto",
            due: "Dovuto",
            failedLoadingBills: "Impossibile caricare le fatture aperte.<br>Si prega di riprovare più tardi.",
            loadingData: "Caricamento dati...",
            noOpenBills: "Nessun conti aperti",
            occupancy: "Occupazione",
            open: "Aperto",
            operator: "Operatore",
            ordersForNow: "Ordini per: Ora",
            ordersForNowOrLater: "Ordini per: Ora o più tardi",
            room: "Sala",
            since: "Da",
            table: "Tavolo",
            title: "Conti aperti",
        },
        pay: {
            approximately: "ca.",
            btnOrderAgain: "Ordinare In Aggiunta",
            cartChangedAndPleaseWaitMessage: "A causa della mancanza di disponibilità o di una modifica del prezzo, almeno un articolo verrà eliminato a breve dal carrello. Attendere qualche secondo per l'aggiornamento.",
            cartChangedMessage: "A causa della mancanza di disponibilità o di una modifica del prezzo, almeno un articolo verrà eliminato dal carrello.",
            cartChangedTitle: "Nuovo prezzo totale",
            consumption: "Consumo",
            discount: "Rabais",
            discountVoucherCode: "Codice sconto / voucher",
            discountsMustCoverWholePayLaterOrder: "Gli sconti devono essere pagati immediatamente oppure applicati al conto.",
            onlyOneReservationCanBeMadeAtTheTime: "È possibile effettuare una sola prenotazione alla volta.",
            enterTip: "Inserire una mancia (opzionale)",
            failedBillInvalidSelection: "Almeno un articolo selezionato è già stato pagato o annullato. Si prega di controllare la selezione.",
            failedBillPaymentInProgress: "È in corso un altro pagamento, le articoli interessati sono stati deselezionati. Effettua un pagamento senza questi articoli o riprova tra qualche minuto.",
            failedEmailNotConfirmed: 'Si prega di registrarsi: Cerchio in alto a destra > "Registrare" > seguire le istruzioni. Già registrato? Cerchio in alto a destra > "Profilo" > "Inviare Nuovamente l’E-mail di Conferma" > aprire e confermare l\'e-mail',
            failedEndUserEmailNotConfirmed: "Questo indirizzo e-mail non è confermato. La preghiamo di chiedere all’utente finale di confermare il proprio indirizzo e-mail.",
            failedIdentityNotSignedUp: 'Si prega di registrarsi: Cerchio in alto a destra > "Registrare"',
            failedEndUserNotSignedUp: "Questo indirizzo e-mail non è registrato. La preghiamo di chiedere all’utente finale di registrarsi.",
            failedNoItemsSelected: "Nessun article sélectionné",
            failedOutOfStock: "La quantità desiderata non è purtroppo disponibile, si prega di regolare il carrello:<br />{0}",
            failedPaymentInProgress: "Un altro pagamento è in corso. Si prega di attendere",
            failedPaymentInvalidCard: "Purtroppo questa marca non è accettata o la carta è stata rifiutata dalla tua banca.",
            failedPaymentUnknownReason: "Pagamento annullato. Si prega di riprovare.",
            failedPaymentOutcomeUnknown: "Non è chiaro se il pagamento con carta sia andato a buon fine, la carta potrebbe essere stata addebitata. Controlla l'ultima transazione sul terminale prima di pagare di nuovo.",
            worldlinePaymentOutcomeUnconfirmed: "Transazione non confermata. Per favore, aggiornare lo stato. Se questo messaggio persiste, verificare il terminale o il dispositivo del cliente. Se la transazione risulta andata a buon fine, contattare il supporto — altrimenti, riprovare. Per favore, salvare i dati di contatto del cliente.",
            updatePaymentStatus: "Aggiorna stato",
            worldlineStatusApproved: "La transazione è stata confermata. Il pagamento è stato accettato.",
            worldlineStatusDeclined: "La transazione non è stata approvata. La carta non è stata addebitata, è possibile riprovare.",
            worldlineTerminalNotConnected: "Pagamento annullato. Il terminale {0} non è collegato. Avvii o riavvii il terminale e controlli che sia collegato.",
            approvedPaymentNotAccepted: "Il pagamento con carta è stato approvato, ma non è stato possibile salvarlo. Non pagare di nuovo – il pagamento deve essere verificato manualmente.",
            fees: "Costi",
            billInTransferMode: "Bill è in modalità di trasferimento.",
            fulfillmentSlotTimedOut: "L'orario selezionato è scaduto. Si prega di selezionare un nuovo orario.",
            isEmailCorrectQuestion: "È corretto: {0}",
            newFulfillmentSlotAvailable: "Nuovo {0} {1} a causa degli articoli selezionati o del timeout.",
            noActivePaymentService: "Nessun Servizio di Pagamento attivo.",
            noFulfillmentSlotAvailable: "Almeno un articolo selezionato non è disponibile, riprovare più tardi o modificare la selezione.",
            tableReservationNoAvailability: "Ci dispiace, nessuna disponibilità. Prova con un’altra data, un altro orario o una diversa dimensione del gruppo.",
            noFulfillmentSlotAvailableV2: "Nessuna disponibilità. {0} potrebbe aggiungere disponibilità in futuro, si prega di controllare qui presto.",
            notAllItemsSelected: "Non hai selezionato tutte le unità di {0}. È corretto?",
            paymentInProgressWarning: "Attenzione, altro pagamento in corso. Se l'hai già autorizzato con il fornitore di pagamenti, l'ordine verrà attivato a breve - si prega di annullare. Se il pagamento non è andato a buon fine o se si desidera ordinare di più, selezionare Ordinare In Aggiunta.",
            paymentRecentlyDoneWarning: 'Attenzione, potenziale doppio ordine. Hai recentemente ordinato con successo, vedi "Ordini" nel menu laterale (cerchio in alto a destra). Vuoi fare un altro ordine?',
            payNow: "Pagare",
            pleaseEnterEndUsersEmail: "La preghiamo di inserire l’indirizzo e-mail dell’utente finale.",
            pleaseEnterYourEmail: "Inserisci il tuo indirizzo e-mail o registrati",
            pleaseEnterRequiredData: "Inserisci i dati richiesti (evidenziati in rosso).",
            pleaseEnterRequiredEndUserData: "La preghiamo di inserire i dati richiesti dell’utente finale (evidenziati in rosso).",
            received: "Ricevuto",
            scheduledTime: "orario programmato",
            tip: "Mancia",
            total: "Totale",
            totalDiscount: "Sconto totale",
            totalDiscountMismatchError: "L’importo dello sconto o del voucher è cambiato. Per favore riprova.",
            twintReturnWarning: "Si prega di tornare al browser dopo il pagamento per accelerare l'ordine e ricevere informazioni importanti.",
            vouchersMustCoverWholePayLaterOrder: "Saldo del voucher troppo basso. Cambia il mezzo di pagamento o riduci il totale del carrello.",
            walleePaymentNotAvailable: "Spiacente, questo metodo di pagamento non è temporaneamente disponibile. Riprovare o provare un altro metodo di pagamento.",
            pricePerMinuteItemRequiresPayLater: "Il tuo ordine contiene un articolo con prezzo al minuto, che può essere ordinato solo con pagamento successivo.",
            pricePerMinuteItemAlreadyRunning: "Il tuo ordine contiene un articolo con prezzo al minuto che è già in corso a questo tavolo.",
        },
        print: {
            orderReceiptPrinted: "Lavoro di stampa inviato",
            failedPrintReceipt: "Lavoro di stampa fallito",
        },
        profile: {
            email: "E-Mail",
            emailConfirmed: "Confermato",
            emailUnconfirmed: "Non confermato",
        },
        qrScanner: {
            pointCameraQr: "Dirige il tuo dispositivo fotografico verso il QR code",
            scanQr: "Scanner il QR code",
        },
        receipt: {
            failedPrintReceipt: "Lavoro di stampa fallito",
            failedSendReceipt: "Non è stato possibile inviare la ricevuta. Si prega di riprovare.",
            noProductionSiteEnabledForRoom: "A questo tavolo / stanza non è assegnata alcuna stampante per ricevute attiva.",
            printReceipt: "Stampare la Ricevuta",
            sendReceipt: "Inviare La Ricevuta",
            sentReceiptTo: "La ricevuta è stata inviata a {0}.",
        },
        renameBillModal: {
            billNameLabel: "Nome del conto",
            billNamePlaceholder: "Nuovo nome del conto...",
        },
        report: {
            paymentMethodsReport: "Rapporto sui mezzi di pagamento",
            noAccessToReports: "Lei non dispone del permesso per visualizzare i report. Contatti il suo amministratore o il supporto Tastier se ritiene che si tratti di un errore.",
        },
        reservationStatesGrid: {
            decline: "Rifiutare",
            accept: "Accettare",
            confirmOrFix: "Confermare, Fissare",
            fix: "Fissare",
            removeFix: "Rimuovere la fissazione",
        },
        roomPlan: {
            failedLoadingTables: "Non è stato possibile caricare le tavole.<br />Si prega di riprovare più tardi.",
            loadingTables: "Caricando le tavole...",
            room: "Sala",
            selectTableToTransferBill: "Selezionare la destinazione",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Impossibile modificare il numero di utenti finali.",
        },
        usesResources: {
            resource: "Risorsa",
            units: "Unità",
            usesResources: "Utilizza risorse",
            number: "Numero of units",
            noResourcesAssigned: "No resource assigned yet..",
        },
    } satisfies Translations);
};

setSharedTranslationsLanguage(clientLanguage());

export function setSharedTranslationsLanguage(language: Language) {
    switch (language) {
        case Language.English:
            setEnglish();
            break;
        case Language.German:
            setGerman();
            break;
        case Language.French:
            setFrench();
            break;
        case Language.Italian:
            setItalian();
            break;
        default:
            setEnglish();
            break;
    }
}
